module.exports = __webpack_public_path__ + "img/1443447819.b7b352f0.jpg";